<h1 translate>{{card.title}}</h1>
<h2 translate>m2.sprint9.cockpit-kontrolle.modellvarianten.subtitle.1</h2>
<app-chart-download-button (buttonClick)="exportTableResultate()">
  <h3 translate>m2.sprint9.cockpit-kontrolle.modellvarianten.table</h3>
</app-chart-download-button>
<app-mv-m2-table-resultate [data]="data?.resultate"></app-mv-m2-table-resultate>
<div style="height: 60px"></div>
<h2 translate>m2.sprint9.cockpit-kontrolle.modellvarianten.subtitle.2</h2>
<app-chart-download-button (buttonClick)="exportTableKoeffiziente()">
  <h3 translate>m2.sprint9.cockpit-kontrolle.modellvarianten.table</h3>
</app-chart-download-button>
<app-mv-m2-table-koeffiziente [data]="data?.koeffiziente"></app-mv-m2-table-koeffiziente>
